import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { MainReducer } from "./Reducers/MainReducer";


export const store = createStore(MainReducer, applyMiddleware(thunk))